import { CircularProgress } from "@mui/material";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import { makeStyles } from "@mui/styles";
import PropTypes from "prop-types";
import React from "react";
import {
  COMPLETED_MESSAGE,
  ERROR_MESSAGE,
  GENERATING_REPORT_MESSAGE,
  PLEASE_DO_NOT_REFRESH_OR_CLOSE_YOUR_SCREEN_MESSAGE,
  YOUR_REPORT_FAILED_TO_GENERATE_PLEASE_TRY_AGAIN_MESSAGE,
  YOUR_REPORT_HAS_BEEN_GENERATED_MESSAGE
} from "../util/messageConstants";
import SlideUpTransition from "./fundamentals/SlideUpTransition";

const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1),
    maxWidth: "200px",
  },
}));

const GenerateReportDownloadDialog = (props) => {
  const classes = useStyles();
  return (
    <Dialog
      className="action-check-dialog"
      fullWidth
      maxWidth="md"
      open={props.isDialogOpen}
      TransitionComponent={SlideUpTransition}
      keepMounted
      onClose={props.onClose}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description">
      <DialogTitle id="alert-dialog-slide-title" className="detail-dialog-title">
        {props.isDownloading ? GENERATING_REPORT_MESSAGE : props.isError ? ERROR_MESSAGE : COMPLETED_MESSAGE}
      </DialogTitle>
      <DialogContent className="action-check-dialog-content">
        <DialogContentText component={"div"} id="alert-dialog-slide-description">
          <Grid container>
            <Grid item xs={12}>
              <Alert
                severity={
                  props.isDownloading
                    ? "warning"
                    : props.isError
                    ? "error"
                    : props.responseMessage === ""
                    ? "success"
                    : "warning"
                }
              >
                {props.isDownloading
                  ? PLEASE_DO_NOT_REFRESH_OR_CLOSE_YOUR_SCREEN_MESSAGE
                  : props.isError
                  ? YOUR_REPORT_FAILED_TO_GENERATE_PLEASE_TRY_AGAIN_MESSAGE
                  : props.responseMessage === ""
                  ? YOUR_REPORT_HAS_BEEN_GENERATED_MESSAGE
                  : props.responseMessage}
              </Alert>
            </Grid>
          </Grid>
        </DialogContentText>
      </DialogContent>
      <DialogActions className="action-check-dialog-buttons">
        <Grid container justifyContent="center">
          {props.responseMessage === "" && (
            <Button
              variant="contained"
              disabled={props.isDownloading}
              color="primary"
              onClick={props.isError ? props.onRetry : props.onDownload}
              fullWidth={true}
              className={classes.button}
            >
              {props.isDownloading ? <CircularProgress size={24} /> : props.isError ? "Generate" : "Download Report"}
            </Button>
          )}
          <Button
            className={classes.button}
            variant="outlined"
            fullWidth={true}
            color="primary"
            onClick={props.onClose}
          >
            OK
          </Button>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

GenerateReportDownloadDialog.propTypes = {
  isDownloading: PropTypes.bool.isRequired,
  isError: PropTypes.bool.isRequired,
  isDialogOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onDownload: PropTypes.func.isRequired,
  onRetry: PropTypes.func.isRequired,
};

export default GenerateReportDownloadDialog;
